const initialState = {
  data: [],
  total: 0, 
  pagination: {
    page: 1, 
    perPage: 10 
  }
}

const ingresosReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_INGRESOS':
      //console.log("Datos guardados en Redux:", action.data)
      return {
        ...state,
        data: action.data.data, 
        total: action.data.total, 
        pagination: {
          ...state.pagination,
          page: action.data.page, 
          perPage: action.data.perPage 
        }
      }
    case 'ADD_INGRESO':
      return {
        ...state,
        data: [action.ingreso, ...state.data],
        total: state.total + 1 
      }
    default:
      return state
  }
}

export default ingresosReducer
